export const primeReactLocaleES = {
  startsWith: 'Empieza con',
  contains: 'Contiene',
  notContains: 'No contiene',
  endsWith: 'Termina con',
  equals: 'Igual a',
  notEquals: 'No igual a',
  noFilter: 'Sin filtro',
  filter: 'Filtro',
  lt: 'Menor que',
  lte: 'Menor o igual que',
  gt: 'Mayor que',
  gte: 'Mayor o igual que',
  dateIs: 'La fecha es',
  dateIsNot: 'La fecha no es',
  dateBefore: 'La fecha es anterior',
  dateAfter: 'La fecha es posterior',
  custom: 'Personalizado',
  clear: 'Borrar todo',
  apply: 'Aplicar',
  matchAll: 'Coincidir con todos',
  matchAny: 'Coincidir con cualquiera',
  addRule: 'Añadir regla',
  removeRule: 'Eliminar regla',
  accept: 'Sí',
  reject: 'No',
  choose: 'Elegir',
  upload: 'Cargar',
  cancel: 'Cancelar',
  completed: 'Completado',
  pending: 'Pendiente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
  dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  monthNames: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
  chooseYear: 'Seleccionar año',
  chooseMonth: 'Seleccionar mes',
  chooseDate: 'Seleccionar fecha',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevHour: 'Hora anterior',
  nextHour: 'Hora siguiente',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Minuto siguiente',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Segundo siguiente',
  am: 'AM',
  pm: 'PM',
  today: 'Hoy',
  weekHeader: 'Sem',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd/mm/yy',
  weak: 'Débil',
  medium: 'Medio',
  strong: 'Fuerte',
  passwordPrompt: 'Introduce la contraseña',
  emptyFilterMessage: 'No hay opciones disponibles',
  searchMessage: '{0} resultados disponibles',
  selectionMessage: '{0} elementos seleccionados',
  emptySelectionMessage: 'Ningún elemento seleccionado',
  emptySearchMessage: 'No se han encontrado resultados',
  emptyMessage: 'No se han encontrado resultados',
  aria: {
    trueLabel: 'Verdadero',
    falseLabel: 'Falso',
    nullLabel: 'No seleccionado',
    pageLabel: 'Página {page}',
    firstPageLabel: 'Primera página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Página siguiente',
    previousPageLabel: 'Página anterior',
    selectLabel: 'Seleccionar',
    unselectLabel: 'Deseleccionar',
    expandLabel: 'Expandir',
    collapseLabel: 'Contraer',
    star: '1 estrella',
    stars: '{star} estrellas',
    selectAll: 'Seleccionar todos los elementos',
    unselectAll: 'Deseleccionar todos los elementos',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    navigation: 'Navegación',
    scrollTop: 'Ir arriba',
    moveTop: 'Mover al inicio',
    moveUp: 'Mover arriba',
    moveDown: 'Mover abajo',
    moveBottom: 'Mover al final',
    moveToTarget: 'Mover al destino',
    moveToSource: 'Mover al origen',
    moveAllToTarget: 'Mover todo al destino',
    moveAllToSource: 'Mover todo al origen',
    rowsPerPageLabel: 'Elementos por página',
    jumpToPageDropdownLabel: 'Ir al desplegable de página',
    jumpToPageInputLabel: 'Ir a la entrada de página',
    selectRow: 'Seleccionar fila',
    unselectRow: 'Deseleccionar fila',
    expandRow: 'Expandir fila',
    collapseRow: 'Contraer fila',
    showFilterMenu: 'Mostrar menú de filtros',
    hideFilterMenu: 'Ocultar menú de filtros',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restricción de filtro',
    editRow: 'Editar fila',
    saveEdit: 'Guardar edición',
    cancelEdit: 'Cancelar edición',
    listView: 'Lista',
    gridView: 'Cuadrícula',
    slide: 'Diapositiva',
    slideNumber: '{slideNumber}',
    zoomImage: 'Zoom de imagen',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    rotateRight: 'Girar a la derecha',
    rotateLeft: 'Girar a la izquierda',
  },
};
